/* eslint-disable import/no-anonymous-default-export */
export default {
  GETUSER: () => `/user`,
  ADDDESCRIPTIONTOSTORE: () => `/user/storefront`,
  ADDSOCIALLINKTOSTORE: () => `/user/storefront`,
  ADDBANNERIMAGETOSTORE: () => `/user/storefront`,
  GETACCESSTOKEN: () => `/instagram/token`,
};
